import { get } from './http';

// Types sourced from https://github.com/ev-proddev/address
// Paths below are relative to that repo root (address-dto/src/main/java/com/experticity/address/dto/).

// ── Types ─────────────────────────────────────────────────────────────────────

/** @source SubdivisionDto.java */
export type Subdivision = {
  subdivisionId: number;
  countryCodeId: number;
  countryAlpha2: string;
  code: string;
  isoCode: string;
  name: string;
  level: string;
  supported: boolean;
  isoStandard: boolean;
  createdTime: number;
  modifiedTime: number;
};

/** @source CountryDto.java */
export type Country = {
  id: number;
  alpha2: string;
  name: string;
  postalCodeRequired: boolean;
  postalCodeValidation: string;
  supported: boolean;
  contactOptInDefault: boolean;
  subdivided: boolean;
  subdivisionRequired: boolean;
  isoStandard: boolean;
  continentId: number;
  createdTime: number;
  modifiedTime: number;
  subdivisions: Subdivision[];
};

/** @source geo/AddressGeocodeRequest.java */
export type GeocodeAddress = {
  text?: string;
  addressId?: number;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  countryCode?: string;
  ip?: string;
  breakCache?: boolean;
};

/** @source geo/AddressGeocodeResult.java */
export type GeocodeResult = {
  geocodeId: number;
  latitude: number;
  longitude: number;
  provider: string;
  lookupDate: number;
  accuracy: number;
  address: GeocodeAddress;
  status: string;
};

// ── API ───────────────────────────────────────────────────────────────────────

export function getCountries(): Promise<Country[]> {
  return get<Country[]>('/xapi/address/pub/1.0/country', { params: { includeSubdivisions: true } });
}

export function getGeocode(text: string): Promise<GeocodeResult> {
  return get<GeocodeResult>('/xapi/address/ext/1.0/geocode/address', { params: { text } });
}
